import BoardContainer from "../board/BoardContainer";

const categories = [
  { postType: 'PT03', title: '질문광장', sectionTitle: '질문광장' },
  { postType: 'PT030', title: '질문답변', sectionTitle: '질문답변' },
  { postType: 'PT031', title: '셀러 질문답변', sectionTitle: '셀러 질문답변' },
];

const Qna = () => {
  return (
    <BoardContainer categories={categories} postType="PT030" />
  );
}

export default Qna;